import isHotkey from 'is-hotkey';
import tools from '../../tools';
import type { EditorPlugin, EventHandler } from '../../types/aha-editor';
import type Tool from '../../tools/Tool';

const ToolsHotkeyActions: EventHandler<KeyboardEvent> = (
  event,
  ahaEditor
): boolean | undefined => {
  // TODO::Hotkeys Use the hotkeys of actually registered plugins, not every tool
  const { editor, controller } = ahaEditor;
  for (const tool of Object.values(tools) as (typeof Tool)[]) {
    const shortcut = tool.currentPlatformShortcut;
    if (!shortcut) continue;

    const shortcuts = shortcut.split(',');
    const shortcutPressed = shortcuts.some((s) => isHotkey(s, event));
    if (!shortcutPressed) continue;

    if (!tool.isEnabled?.({ editor, controller })) continue;

    event.preventDefault();
    tool.action({ editor, controller });
    controller.actionReRenderToolbar();
    return true;
  }
};

const HotkeysPlugin: EditorPlugin = {
  name: 'Hotkeys plugin',
  handlers: {
    onKeyDown: ToolsHotkeyActions,
  },
};

export default HotkeysPlugin;
